import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuoteResponse } from '../../api/payamigo';

import './quote-summary.scss';

interface IQuoteSummaryProps {
  quote: QuoteResponse;
  isLoading?: boolean;
}

const QuoteSummary: React.FC<IQuoteSummaryProps> = ({ quote, isLoading = false }) => {
  const { t } = useTranslation();

  return (
    <div className="quote-summary">
      <h3 className="quote-summary-title">
        {t('PAY_AMIGO.QUOTE_SUMMARY', { defaultValue: 'Quote Summary' })}
        {isLoading && <span className="refreshing"> (refreshing...)</span>}
      </h3>
      <div className="quote-details">
        <div className="quote-detail-item">
          <span className="label">{t('PAY_AMIGO.PRICE', { defaultValue: 'Price' })}</span>
          <span className="value">{`${quote.price} ${quote.underlying_coin}`}</span>
        </div>

        {/* Exchange Fee (quoted_fee) - only if exists and not zero */}
        {'quoted_fee' in quote && quote.quoted_fee !== undefined && quote.quoted_fee !== 0 && (
          <div className="quote-detail-item">
            <span className="label">{t('PAY_AMIGO.EXCHANGE_FEE', { defaultValue: 'Exchange Fee' })}</span>
            <span className="value">{`${quote.quoted_fee} ${quote.quoted_coin}`}</span>
          </div>
        )}

        {/* Service Fee (underlying_fee) */}
        <div className="quote-detail-item">
          <span className="label">{t('PAY_AMIGO.SERVICE_FEE', { defaultValue: 'Service Fee' })}</span>
          <span className="value">{`${quote.underlying_fee} ${quote.underlying_coin}`}</span>
        </div>

        {/* Receive Amount (quoted_amount) */}
        <div className="quote-detail-item">
          <span className="label">{t('PAY_AMIGO.RECEIVE_AMOUNT', { defaultValue: 'Receive Amount' })}</span>
          <span className="value">{`${quote.quoted_amount} ${quote.quoted_coin}`}</span>
        </div>

        {/* Total */}
        <div className="quote-detail-item total">
          <span className="label">{t('PAY_AMIGO.TOTAL', { defaultValue: 'Total' })}</span>
          <span className="value">{`${quote.underlying_amount} ${quote.underlying_coin}`}</span>
        </div>
      </div>
    </div>
  );
};

export default QuoteSummary;

